<template>
  <svg class="icon" aria-hidden="true">
    <use :xlink:href="iconName" />
  </svg>
</template>
<script>
export default {
  name: 'iconSvg',
  props: {
    name: String
  },
  computed: {
    iconName() {
      return '#icon' + this.name
    }
  }
}
</script>
<style lang="less" scoped>
// .icon {
//   width: 1em;
//   height: 1em;
//   vertical-align: -0.15em;
//   fill: currentColor;
//   overflow: hidden;
// }
</style>
